import { Button, CloseButton, Form, Modal } from "react-bootstrap"
import useRestoreCouncilor from "../hooks/useRestoreCouncilor";

function Restore(props) {
    const councilorId = props.data?.id;
    const { handleSave, loading} = useRestoreCouncilor(councilorId);

    const onFormSubmit = e => {
        e.preventDefault();
        const formData = new FormData();
        formData.append('id', props.data?.id);
        handleSave(formData);
    };
    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            backdrop="static"
        >
            <Modal.Header>
                <Modal.Title id="contained-modal-title-vcenter">
                    Възстановяване
                </Modal.Title>
                <CloseButton onClick={props.onHide} variant='white'/>
            </Modal.Header>
            <Modal.Body>
                <Form id="delete-commission" onSubmit={onFormSubmit}>
                    <Form.Control
                        name='id'
                        type="text"
                        hidden
                        value={props.data.id}
                    />
                    <h4>Сигурни ли сте ?</h4>
                    <p>
                        След възстановяване, този съветник ще се завърне в секцията "Настоящи общински съветници"
                    </p>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="success" form='delete-commission' type="submit" disabled={loading}>
                    Възстановяване
                </Button>
                <Button variant="secondary" onClick={props.onHide}>Затвори</Button>
            </Modal.Footer>
        </Modal>
    )
}
export default Restore